import { defineStore } from "pinia";
import { ref, type Ref } from "vue";
import { api } from "@/app/services/api.service";

export const useIntegrationStore = defineStore("integrations", () => {
  const error: Ref<any> = ref(null);
  const access_level_success: Ref<any> = ref(null);
  const access_level_error: Ref<any> = ref(null);
  const go_live: Ref<any> = ref(null);
  const access_key_error: Ref<any> = ref(null);
  const access_levels: Ref<any> = ref(null);
  const access_keys: Ref<any> = ref(null);
  const endpoints: Ref<any> = ref(null);
  const sandbox_endpoints: Ref<any> = ref(null);
  const production_endpoints: Ref<any> = ref(null);
  const endpoint_error: Ref<any> = ref(null);
  const revoke_access: Ref<any> = ref(null);
  const accountSummary: Ref<any> = ref(null);
  const logs: Ref<any> = ref(null);

  const fetchAccessLevels = async () => {
    return api().get("/third-party-api/level/all")
      .then((response) => {
        access_levels.value = response.data;
      })
      .catch((err) => {
        access_level_error.value = err.response?.data;
      });
  };

  const doAddAccessAreas = async (data: any) => {
    return api().post("/third-party-api/access-list/create", data)
      .then((response) => {
        access_level_success.value = response.data;
      })
      .catch((err) => {
        access_level_error.value = err.response?.data;
      });
  };

  const generateAccessKeys = async (data: any) => {
    return api().post("/third-party-api/access/setup", data)
      .then((response) => {
        access_keys.value = response.data;
      })
      .catch((err) => {
        access_key_error.value = err.response?.data;
      });
  };

  const doGoLive = async (data: any) => {
    return api().post("/third-party-api/access/go-live", data)
      .then((response) => {
        go_live.value = response.data;
      })
      .catch((err) => {
        access_key_error.value = err.response?.data;
      });
  };

  const doRevokeAccess = async (data: any) => {
    return api().post("/third-party-api/access/revoke", data)
      .then((response) => {
        revoke_access.value = response.data;
      })
      .catch((err) => {
        access_key_error.value = err.response?.data;
      });
  };

  const fetchAccessKeys = async (data: { id: string | number }) => {
    return api().get("/api/third-party/access-key/by-account/" + data.id)
      .then((response) => {
        access_keys.value = response.data;
      })
      .catch((err) => {
        access_key_error.value = err.response?.data;
      });
  };

  const fetchAllEndpoints = async () => {
    return api().get("/third-party-api/endpoint/all")
      .then((response) => {
        endpoints.value = response.data;
      })
      .catch((err) => {
        endpoint_error.value = err.response?.data;
      });
  };

  const fetchApiLogs = async (data: string) => {
    return api().get("/third-party-access/request-logs?" + data)
      .then((response) => {
        logs.value = response.data;
      })
      .catch((err) => {
        endpoint_error.value = err.response?.data;
      });
  };

  const fetchUserProductionEndpoints = async (userId: string | number) => {
    return api().get("/third-party-api/access/live/" + userId)
      .then((response) => {
        production_endpoints.value = response.data;
      })
      .catch((err) => {
        endpoint_error.value = err.response?.data;
      });
  };

  const fetchUserSandboxEndpoints = async (userId: string | number) => {
    return api().get("/third-party-api/access/sandbox/" + userId)
      .then((response) => {
        sandbox_endpoints.value = response.data;
      })
      .catch((err) => {
        endpoint_error.value = err.response?.data;
      });
  };

  const fetchAccountSummary = async (userId: string | number) => {
    return api().get("/billing/transaction/partner-account/" + userId)
      .then((response) => {
        accountSummary.value = response.data;
      })
      .catch((err) => {
        endpoint_error.value = err.response?.data;
      });
  };

  return {
    error,
    access_level_success,
    access_level_error,
    go_live,
    access_key_error,
    access_levels,
    access_keys,
    endpoints,
    sandbox_endpoints,
    production_endpoints,
    endpoint_error,
    revoke_access,
    accountSummary,
    logs,
    fetchAccessLevels,
    doAddAccessAreas,
    generateAccessKeys,
    doGoLive,
    doRevokeAccess,
    fetchAccessKeys,
    fetchAllEndpoints,
    fetchApiLogs,
    fetchUserProductionEndpoints,
    fetchUserSandboxEndpoints,
    fetchAccountSummary
  };
});
